import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { reais } from "@/lib/dinheiro";
import { cn } from "@/lib/cn";
import { categoriasDaLinha, linhasVisiveis, percentual, valorDaCategoria } from "./linhas-do-dre";
import type { ColunaDoDre } from "./TabelaDoDre";

/** O DRE no celular: uma lista empilhada com o valor principal e, embaixo, o de comparação. */
export function ListaDoDre({ principal, comparacao }: { principal: ColunaDoDre; comparacao?: ColunaDoDre | null }) {
  const [aberta, setAberta] = useState<string | null>(null);
  const linhas = linhasVisiveis([principal.dre, ...(comparacao ? [comparacao.dre] : [])]);
  return (
    <ul className="divide-y divide-zinc-100 dark:divide-border/50">
      {linhas.map((l) => {
        const v = l.valor(principal.dre);
        const cats = categoriasDaLinha(l, [principal.dre]);
        const abrir = cats.length > 0;
        return (
          <li key={l.chave} className={cn(l.total && "bg-zinc-50/70 dark:bg-muted/30")}>
            <button type="button" disabled={!abrir} aria-expanded={aberta === l.chave} onClick={() => setAberta(aberta === l.chave ? null : l.chave)} className="flex w-full items-start gap-2 px-4 py-2.5 text-left">
              <ChevronRight className={cn("mt-0.5 h-3.5 w-3.5 shrink-0 text-zinc-400 transition-transform", !abrir && "invisible", aberta === l.chave && "rotate-90")} />
              <span className="min-w-0 flex-1">
                <span className={cn("block text-sm", l.total ? "font-semibold text-zinc-900 dark:text-foreground" : "text-zinc-700 dark:text-foreground/80")}>
                  {l.rotulo}
                  {l.estimado?.(principal.dre) && <span className="ml-1.5 rounded-full bg-amber-50 px-1.5 py-0.5 text-[10px] font-semibold text-amber-700 dark:bg-amber-500/10 dark:text-amber-400">estimado</span>}
                </span>
                {comparacao && (
                  <span className="block text-[11px] text-zinc-500 dark:text-muted-foreground">
                    {comparacao.rotulo}: {reais(l.valor(comparacao.dre))}
                  </span>
                )}
              </span>
              <span className="text-right">
                <span className={cn("block text-sm tabular-nums", l.total && "font-semibold", l.forte ? (v >= 0 ? "text-emerald-600" : "text-red-600") : "text-zinc-900 dark:text-foreground")}>{reais(v)}</span>
                <span className="block text-[11px] tabular-nums text-zinc-500 dark:text-muted-foreground">{percentual(v, principal.dre)}</span>
              </span>
            </button>
            {aberta === l.chave && (
              <ul className="pb-2">
                {cats.map((c) => (
                  <li key={c.id} className="flex items-center gap-2 py-1 pl-10 pr-4 text-[13px] text-zinc-600 dark:text-foreground/70">
                    <span className="h-2 w-2 shrink-0 rounded-[2px]" style={{ backgroundColor: c.cor || "#A1A1AA" }} />
                    <span className="min-w-0 flex-1 truncate">{c.nome}</span>
                    <span className="tabular-nums">{reais(valorDaCategoria(l, principal.dre, c.id))}</span>
                  </li>
                ))}
              </ul>
            )}
          </li>
        );
      })}
    </ul>
  );
}
